const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function OfficeSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Licencias Microsoft Office', item: `${SITE_URL}/office` },
    ],
  };

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Licencias Microsoft Office Originales - Digital Licence Store',
    url: `${SITE_URL}/office`,
    numberOfItems: 10,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 'Office 365 última versión - 1 cuenta',
          description: 'Licencia de por vida Office 365 para 1 usuario. Incluye Word, Excel, PowerPoint, Outlook, Teams y OneDrive 1TB.',
          url: `${SITE_URL}/office`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '129990',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/office`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '72', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: 'Licencia Original Office 2024 Professional Plus',
          description: 'Licencia de por vida Office 2024 Pro Plus para 1 PC. Incluye Word, Excel, PowerPoint, Outlook, Access y Publisher.',
          url: `${SITE_URL}/office`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '69900',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/office`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '59', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Product',
          name: 'Licencia Office 2024 Pro Plus LTSC 1 cuenta',
          description: 'Licencia de por vida Office 2024 LTSC para 1 PC con soporte extendido 5 años.',
          url: `${SITE_URL}/office`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '89900',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/office`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '58', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          '@type': 'Product',
          name: 'Licencia Original Office 2021 Professional Plus',
          description: 'Licencia de por vida Office 2021 Pro Plus para 1 PC. Incluye Word, Excel, PowerPoint, Outlook, Access y Publisher.',
          url: `${SITE_URL}/office`,
          brand: { '@type': 'Brand', name: 'Microsoft' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '49950',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/office`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '32', bestRating: '5' },
        },
      },
    ],
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Licencias Microsoft Office Originales Colombia - Digital Licence Store',
    description: 'Compra licencias originales de Microsoft Office 2021, 2024 y Office 365 al mejor precio en Colombia. Entrega inmediata por email. Descuentos hasta 75%.',
    url: `${SITE_URL}/office`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
